@use "~theme/breakpoints";
@use "~theme/typography";

.dateContainer {
  padding: 10px 0px 10px 10px;
  background-color: var(--white);
  width: 100%;
  @include breakpoints.desktop {
    padding: 20px;
  }
}

.officeSection {
  padding: 14px 14px 0px;
}

.borderDivider {
  border: 1px solid rgba(0, 51, 102, 0.3);
  padding: 0px 10px;
}

.borderDividerSection {
  border: 1px solid rgba(0, 51, 102, 0.3);
  padding: 0px;
  width: 110%;
  margin-left: -20px;
}

.mobileView {
  @include breakpoints.desktop {
    display: none;
  }
}

.noAvailableDoctors {
  @include typography.body;
  color: var(--blue-02);
}

/* --- footer styles ---------------------------- */

.footer {
  display: flex;
  flex-direction: column;
  padding: 30px 5%;
  background: var(--interface-100);
  border-top: 1px solid var(--gray-06);
  margin: 20px -14px 0px -14px;

  @include breakpoints.desktop {
    flex-direction: row;
    padding-top: 44px;
    padding-left: 0;
    padding-right: 0;
  }
}

.footerSection {
  flex: 1;

  @include breakpoints.desktop {
    padding-top: 12px;
    padding-bottom: 12px;
  }
}

.footerLeft {
  @include breakpoints.desktop {
    margin-left: 20%;
  }
}

.footerRight {
  @include breakpoints.desktop {
    margin-right: 20%;
  }
}

.footerDivider {
  margin: 28px 25%;
  height: 1px;
  border: 0;
  background-color: var(--blue-01-at-30);

  @include breakpoints.desktop {
    flex-shrink: 0;
    height: auto;
    width: 1px;
    margin: 0 64px;
  }
}

.footerHeading {
  @include typography.heading4;
  text-align: center;
  margin: 0;

  @include breakpoints.desktop {
    padding-bottom: 8px;
  }
}

.footerHeadingWithTooltip {
  display: flex;
  justify-content: center;

  > :first-child {
    margin-right: 8px;
  }
}

.footerParagraph {
  text-align: center;
  margin: 8px 0 0;

  @include breakpoints.desktop {
    padding: 0px;
    margin: 0px;
  }
}

.footerPhoneLink {
  white-space: nowrap;
}

.footerLinkContainer {
  text-align: center;
  margin: 32px 0;

  @include breakpoints.desktop {
    margin: 16px 0;
  }
}

.footerLink {
  color: var(--black);
  text-transform: uppercase;
}

.footerNextBtn {
  width: 100%;
  height: 53px;

  @include breakpoints.desktop {
    width: 12%;
    margin: 30px 40px 30px 0px;
    float: right;
  }
}

.footerPortal {
  margin: 0px -14px;
}

.weekContainer {
  width: 100%;
  height: 50px;
  @include breakpoints.desktop {
    height: 80px;
  }
}

.dayContainer {
  width: 68px;
  height: 44px;
  background: var(--white);
  border: 1px solid var(--gray-03);
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  float: left;
  padding: 2px;
  margin: 0px 5px;
  text-align: center;
  cursor: pointer;

  @include breakpoints.desktop {
    padding: 10px;
    width: 98px;
    height: 70px;
  }

  @include breakpoints.mobile-small {
    width: 16%;
  }
  @include breakpoints.mobile-small-1 {
    width: 17%;
  }
  @include breakpoints.mobile-large-1 {
    width: 18%;
  }
}

.daySelected {
  border: 1px solid var(--blue-02);
}

.dayWords {
  font-size: 1rem;
  line-height: 150%;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--blue-01);
  font-weight: 600;
  height: 20px;

  @include breakpoints.desktop {
    @include typography.body-large;
    text-transform: uppercase;
    color: var(--blue-01);
  }
}

.monthYear {
  @include typography.caption;
  color: var(--black);

  @include breakpoints.desktop {
    font-weight: 400;
    font-size: 16px;
    color: var(--black);
  }
}

.arrow {
  float: left;
  margin: 20px 0px;
}

.arrowLeft {
  position: absolute;
  margin: 10px 0px 10px -10px;

  @include breakpoints.desktop {
    margin-right: 8px;
  }
}

.arrowRight {
  margin: 10px 0px 10px -10px;
  position: absolute;
  right: 10px;

  @include breakpoints.desktop {
    margin-left: 8px;
  }
}

.hideTimeSection {
  display: none;
}

.showTimeSection {
  display: block;
}

.customSteps {
  display: flex;
  padding: 16px 20px;
  background-color: var(--white);
  border-bottom: 1px solid var(--blue-01-at-30);
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  img { margin-right: 8px; }

  h1 {
    @include typography.heading4;
    color: var(--blue-01);
    margin: 0;
    padding: 0;
    flex: 1;
  }

  div {
    @include typography.button-edit;
    color: var(--blue-01);
    text-decoration: none;
    border-bottom: 1px solid var(--blue-02);
    outline-offset: 8px;
    outline: none;
  }

  .headlineLimitedAvailability {
    background-color: var(--blue-03);
    height: 34px;
    color: var(--blue-01);
    display: flex;
    justify-content: center;
    padding: 8px;
    letter-spacing: 0.12em;
    font-size: 1rem;
  }
}

.vehModal {
  width: 80%;
  max-width: 80%;
  font-size: 14px;

  input { margin-right: 5px; }

  .vehTerms {
    font-size: 10px;
    line-height: 12px;
    margin: 15px 0px;
  }

  .interrogative {
    @include typography.body-semibold;
    text-align: center;
    padding-bottom: 20px;
    margin: 0;
  }

  .qualifier {
    text-align: center;
    padding-bottom: 20px;
    margin: 0;
  }

  .button {
    flex: 1;
    margin: 0 8px;
    font-size: 16px;

    &:first-child { margin-left: 0; }
    &:last-child  { margin-right: 0; }
  }

  .buttons {
    display: flex;
    flex-direction: row;
    margin-top: 25px;
  }

  .buttonRestrict {
    width: 100%;
    margin: 5px 0px;
    font-size: 14px;
  }
}

h1.selectOption {
  color: var(--black);
  font-size: 18px;
}

.headline {
  font-weight: 600;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--black);
  margin-top: 0px;
}

.buttonWrapper {
  .container {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .tooltipContainer {
    background-color: var(--blue-02);
    color: var(--white);
    border-radius: 4px;
    visibility: hidden;
    position: absolute;
    z-index: var(--float);
    width: 300px;
    padding: 4px 8px;
  }

  .tooltipContainer p {
    @include typography.body;
    margin-top: 0;
  }

  .tooltipContainer p:last-child { margin-bottom: 0; }

  .tooltipPositionTop {
    bottom: 100%;
    left: 0;
    margin-left: 12px;
    margin-bottom: 8px;
  }

  .tooltipPositionTop::after {
    content: " ";
    position: absolute;
    top: 100%;
    left: 72px;
    margin-left: -8px;
    border-width: 8px;
    border-style: solid;
    border-color: var(--blue-02) transparent transparent transparent;
  }

  .tooltipVisible { visibility: visible; }

  .content { padding: 12px; }

  .contentContainer {
    display: flex;
    flex-direction: row;
  }

  .buttonIcon {
    border: none;
    outline: none;
    padding: 0;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
  }
}

.classRed   { color: white; padding-top: 5px; }
.classWhite { color: white; padding-top: 5px; }

.iconCircle { width: 24px; height: 24px; }

.restrictVEHContent { margin-bottom: 10px; }

.smsFooter {
  padding: 0px 5% 20px 5%;
  text-align: center;
  margin-top: -16px;
  font-size: 12px;
  line-height: 140%;
}

/* ----------------------------
   VEH MODAL SECTION
-----------------------------*/

.newvehModal {
  padding: 0px 20px 20px 20px;
  margin: 0px;

  @include breakpoints.desktop-medium {
    height: auto;
  }

  @include breakpoints.desktop-large {
    height: auto;
  }

  .conClass { }

  .nvehheader {
    /* existing styles */
    font-family: proxima-nova, sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 120%;
    color: var(--black);
    margin: 0px 0px 5px 0px;
  }

  .imgPatient {
    width: 100%;
    height: 200px;                /* base height */
    object-fit: cover;
    object-position: left center; /* align left as requested */
    transition: height 0.2s ease;
  }

  .newP1 {
    font-family: proxima-nova, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;

    span {
      font-family: proxima-nova, sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
    }
  }

  .newL1 {
    font-family: proxima-nova, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
  }

  .listContainer {
    display: block;
    overflow: auto;
    padding-bottom: 10px;
  }

  .listImg  { width: 5%;  float: left; }
  .listText { width: 95%; float: left; }

  .newL2 {
    font-family: proxima-nova, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;

    ul {
      list-style: none;
      padding: 0px;
    }
  }

  .buttonAcc {
    width: 100%;
    font-family: proxima-nova, sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 1.92px;
    text-align: center;
    text-transform: uppercase;
    color: white;
  }

  .btnGoContainer { text-align: center; }

  .iconBack { }

  .buttonGo {
    font-family: proxima-nova, sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    padding: 15px 0px;
    cursor: pointer;
  }
}

.newvehModal:has(.newL2 ul li:nth-of-type(3)) .imgPatient {
  height: 120px !important;
}

.officeIcon {
  margin-top: -20px;
}

.medicaid {
  position: relative;
  border-bottom: none;
  margin-left: -30px;
  color: var(--blue-01);
  font-size: 10px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  outline: none;
  outline-offset: inherit;
  margin-top: 3px;
  margin-bottom: 0px;
}
.mediText {
  position: absolute;
  top: 4px;
}

.boldUnderline {
    text-decoration-line: underline;
    font-weight: 700;
}

.customOfficeSteps {
  padding: 5px 20px 8px 20px;
}
